'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hour;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/hour.js
// module id = 675
// module chunks = 0